import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { filterErrorHandler } from "../../../hoc/Shared/utility";

import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import Button from "../../../components/Button/Button";
import DataTable from "../../../components/Datatable/DataTable";

import { getBonusMessageSummaryDetails } from "../../../store/ducks/report/actions";

class BonusMessageSummaryDetails extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [],
            loading: true,
            page: 1,
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalPages: 0,
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: null,
            totalRecords: 0,
            searchValue: "",
            pageShow: "listing",
            redirectParam: {}
        }
    }

    componentDidMount(){
        const data = this.getFilterList();
        this.props.getBonusMessageSummaryDetails(data);
    }

    shouldComponentUpdate(nextProps, nextState){
        if (nextProps.reportData !== this.props.reportData && nextProps.reportData !== undefined) {
            if (nextProps.reportData.status === 200 && nextProps.reportData.data.msgType === "success") {
                console.log(nextProps.reportData)
                this.setState({
                    loading: false,
                    data: nextProps.reportData.data.data,
                    totalPages: nextProps.reportData.data.totalPages,
                    totalRecords: nextProps.reportData.data.totalRecords
                });
            }
            else{
                this.setState({
                    data: [],
                    loading: false,
                    totalPages: 0,
                    totalRecords: 0
                }, () => {
                    filterErrorHandler(nextProps.reportData.data.message);
                });
            }
        }

        return true;
    }

    getFilterList = () => {
        const listingArr = {};

        let availablePage = this.state.activePage;
        if (this.state.totalRecords > 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }

        listingArr.created_at = this.props.detailsParam.date;
        listingArr.email_content_type = this.props.detailsParam.type;
        listingArr.read_status = this.props.detailsParam.status;
        listingArr.country_id = this.props.currentUser.country_id;
        listingArr.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);

        this.setState({
            loading: true,
            data: []
        });
        return listingArr;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: []
        }, () => {
            const data = this.getFilterList();
            this.props.getBonusMessageSummaryDetails(data);
        });
    }

    datatablesChangeHandler = (val, act) => {
        let search = "";
        search = (act === 'searchValue') ? val.target.value : val;

        this.setState({
            [act]: search,
            loading: true,
            data: []
        }, () => {
            const data = this.getFilterList();
            this.props.getBonusMessageSummaryDetails(data);
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit))
        return <span>{rowNumber}</span>;
    };

    changePageHandler = (page) => {
        this.setState({
            pageShow: page
        });
    }

    redirectHandler = (e, id, name) => {
        e.preventDefault();
        this.setState({
            pageShow: "redirect",
            redirectParam: {
                id: id,
                name: name
            }
        });
    }

    render(){
        const { t } = this.props;
        const columns = [
            { text: t('global.no'), dataField: 'no', formatter: this.noFormatter, headerStyle: { width: '60px', textAlign: 'center' } },
            { text: t("report.username"), dataField: 'username', sort: true, onSort: (field, order) => this.onSort(field, order) },
        ];
        let data = this.state.data ? this.state.data.map((val, idx) => {
            return {
                no: idx,
                username: val.username
            }
        }) : [];

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                <>
                 <div className='breadcrumb-header'>
                        <div className='d-flex'>
                            <div>
                                <div className="btn-group">
                                    <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler(this.props.detailsParam.returnPage)} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row row-sm'>
                        <div className='col-lg-12 col-xl-12 col-md-12 col-sm-12'>
                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <h4 className='card-title mb-1'>{t(`report.bonus-message-summary-details`)}</h4>
                                </div>
                                <div className='card-body'>
                                    <DataTable
                                        keyField='no'
                                        data={data}
                                        columns={columns}
                                        activePage={this.state.activePage}
                                        limit={this.state.limit}
                                        totalItems={this.state.totalRecords}
                                        paginationHandler={(val) => this.datatablesChangeHandler(val, 'activePage')}
                                        sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'limit')}
                                        searchChangeHandler={(val) => this.datatablesChangeHandler(val, 'searchValue')}
                                        searchValue={this.state.searchValue}
                                        classValue='dataTable table-bordered text-justify text-center'
                                        loading={this.state.loading}
                                        hideSearchBar={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )}
            </Auxiliary>
        )
    }
}

const mapStateToProps = state => {
    return {
        reportData: state.report.get_bonus_message_summary_details_data,
        currentUser: state.currentUser.data
    }
}

const mapDispatchToProps = {
    getBonusMessageSummaryDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(BonusMessageSummaryDetails));